var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLines = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M13.917 2.564a.25.25 0 0 1 .019.353l.371.335-.371-.335-4.5 5a.25.25 0 0 1-.288.062L5.16 6.204l-.34-.15-.243.282L1.94 9.413l.328.28-.328-.28a.25.25 0 1 1-.38-.325l3-3.5a.25.25 0 0 1 .292-.066L8.854 7.3l.332.148.243-.27 4.135-4.595a.25.25 0 0 1 .353-.019ZM14.917 6.564a.25.25 0 0 1 .019.353l.371.335-.371-.335-4.5 5a.25.25 0 0 1-.287.062l-3.99-1.774-.34-.15-.243.282-2.636 3.076.328.28-.328-.28a.25.25 0 1 1-.38-.325l3-3.5a.25.25 0 0 1 .292-.066L9.854 11.3l.332.148.242-.27 4.136-4.595a.25.25 0 0 1 .353-.019Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLines);
export default ForwardRef;